module.exports = __webpack_public_path__ + "video/B-A-005_SAF_BTB_IncidentResponse.f3d5b925.vtt";